"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShadowSettingKeySchema = void 0;
const zod_1 = require("zod");
exports.ShadowSettingKeySchema = zod_1.z.enum(['NONE', 'HARD', 'MEDIUM', 'SOFT']).optional();
//# sourceMappingURL=shadow-setting.js.map